module.exports = __webpack_public_path__ + "static/media/IMPS.13784915.svg";